<template>
  <div class="app">
    <slot name="header">
      <header class="app__header">
        <div class="app__header__left">
          <div
            class="logoMitma"
            @click="openMTMS"
          >
            <img
              class="header__img-logo"
              src="@/assets/images/logoFomento.svg"
              alt="Logo MITMA"
            />
          </div>
          <div
            class="logoCarreteras"
            @click="goToHome"
          >
            <img
              class="header__img-logo"
              src="@/assets/images/Logo-mapa-carreteras-2026.png"
              alt="Logo Carreteras"
            />
          </div>
        </div>
      </header>
    </slot>
    <main class="main">
      <div class="not-found-content">
        <img
          class="not-found-image"
          src="@/assets/images/404.png"
          alt="404 Not Found"
        />
        <p>Lo sentimos, pero no hemos podido encontrar esta página.</p>
        <router-link
          :to="{ name: 'Home' }"
          class="custom-button"
        >
          Volver al Mapa de Carreteras
        </router-link>
      </div>
    </main>
  </div>
</template>

<script setup>
import {useRouter} from 'vue-router';

const router = useRouter();

function goToHome() {
  router.push({name: 'Home'});
}
function openMTMS() {
  window.open('https://www.mitma.gob.es/');
}
</script>

<style lang="scss" scoped>
.app {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100dvh;
  width: 100%;

  &__header {
    align-items: center;
    background-color: $brand__color--blue;
    display: flex;
    min-height: $brand__boxspace--headerheight;
    position: relative;
    width: 100%;
    z-index: 20;

    &__left {
      display: none;
      align-items: center;
      display: flex;
      flex: 0 0 100%;
      height: 100%;
    }
  }
}
.logoMitma {
  display: flex;
  width: 14.75rem;
  cursor: pointer;
}
.logoCarreteras {
  display: flex;
  width: 11.28rem;
  cursor: pointer;
}
.main {
  text-align: center;
}

.not-found-content {
  max-width: 400px;

  .p {
    font-size: 18px;
  }

  .custom-button {
    background-color: $brand__color--blue;
    color: white;
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    margin-top: 20px;
    cursor: pointer;
    font-size: 14px;
    font-family: sans-serif;

    &:hover {
      background-color: rgba($brand__color--blue, 0.8);
    }
  }
}

.not-found-image {
  width: 100%;
  max-width: 300px;
}
</style>
